export default __webpack_public_path__ + "static/media/columns.f95e6371.svg";